import {
  Grid,
  InputAdornment,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import { FormikErrors } from "formik";
import theme from "src/theme";
import { WorkoutFormValues } from "../EditWorkoutModal/EditWorkoutModal";
import useStyles from "./WorkoutForm.style";

interface SwimWorkoutFormProps {
  values: WorkoutFormValues;
  errors: FormikErrors<WorkoutFormValues>;
  handleChange: (
    field: string,
  ) => (event: React.ChangeEvent<HTMLInputElement>) => void;
  setFieldValue: (field: string, value: any) => void;
}

const SwimWorkoutForm = ({
  values,
  errors,
  handleChange,
  setFieldValue,
}: SwimWorkoutFormProps) => {
  const classes = useStyles();

  const handleNumberChange = (
    field: string,
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const value = event.target.value;
    // Only update if the value is a valid number or empty
    if (value === "" || /^[0-9]*\.?[0-9]*$/.test(value)) {
      handleChange(field)(event as React.ChangeEvent<HTMLInputElement>);
    }
  };

  return (
    <>
      <Grid xs={12}>
        <InputLabel htmlFor="name" className={classes.inputLabel}>
          <Typography variant="subtitle1">Distance</Typography>
        </InputLabel>
        <TextField
          fullWidth
          type="text"
          variant="outlined"
          value={values.distance}
          placeholder="Distance"
          error={!!errors.distance}
          helperText={errors.distance}
          InputProps={{
            className: classes.input,
            endAdornment: (
              <InputAdornment
                position="end"
                sx={{ marginRight: theme.spacing(1) }}
              >
                Yards
              </InputAdornment>
            ),
          }}
          onChange={(e) => handleNumberChange("distance", e)}
        />
      </Grid>
      <Grid xs={12}>
        <InputLabel htmlFor="name" className={classes.inputLabel}>
          <Typography variant="subtitle1">Description</Typography>
        </InputLabel>
        <TextField
          multiline
          rows={4}
          fullWidth
          variant="outlined"
          value={values.description}
          placeholder="Description"
          error={!!errors.description}
          helperText={errors.description}
          InputProps={{
            className: classes.input,
          }}
          onChange={(e) =>
            handleChange("description")(
              e as React.ChangeEvent<HTMLInputElement>,
            )
          }
        />
      </Grid>
    </>
  );
};

export default SwimWorkoutForm;
